import {
    ADD_CHECKOUT_SUCCESS,
    ADD_CHECKOUT_ERROR,
    FETCH_CHECKOUT_REQUEST,
    FETCH_CHECKOUT_SUCCESS,
    FETCH_CHECKOUT_ERROR,
} from './checkout.constants';

const initialState = {
    data: {},
    error: {},
    isLoading: false,
    updateCheckout: {
        isSuccess: false,
        error: {},
    },
    addCheckout: {
        isSuccess: false,
        error: {},
    },
};

export const checkoutReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CHECKOUT_REQUEST: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case FETCH_CHECKOUT_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                data: action.payload,
                error: {},
            };
        }
        case FETCH_CHECKOUT_ERROR:
            return {
                ...state,
                isLoading: false,
                error: { errorMessage: action.payload },
            };
        case ADD_CHECKOUT_SUCCESS: {
            return {
                ...state,
                addCheckout: { isSuccess: true, error: {} },
                updateCheckout: { isSuccess: false, error: {} },
            };
        }
        case ADD_CHECKOUT_ERROR: {
            return {
                ...state,
                addCheckout: {
                    isSuccess: false,
                    error: { errorMessage: action.payload },
                },
                updateCheckout: { isSuccess: false, error: {} },
            };
        }
        default:
            return state;
    }
};
